// The backend user model has no "store / seller name" field. We keep it as a
// local-only enhancement, keyed by user id, merged onto the user object after
// every auth/profile call so the rest of the UI can keep using `user.sellerName`.

const STORE_KEY = "easylister.profileExtras.v1";

const readAll = () => {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const writeAll = (all) => {
  try {
    localStorage.setItem(STORE_KEY, JSON.stringify(all));
  } catch {
    // ignore
  }
};

export const getProfileExtras = (userId) => (userId ? readAll()[userId] || {} : {});

export const setProfileExtras = (userId, extras) => {
  if (!userId) return;
  const all = readAll();
  all[userId] = { ...all[userId], ...extras };
  writeAll(all);
};

export const withProfileExtras = (user) =>
  user ? { ...user, ...getProfileExtras(user.id) } : user;
